/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// GET PARAMS FROM URL
const params = new URL(window.location).searchParams

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      title: params.get('title') ? params.get('title') : null,
      date: params.get('date') ? params.get('date') : null,
      noLine: params.get('noline')
        ? params.get('noline').toLowerCase() === 'true'
        : false
    }
  }

  render() {
    /*
      console.log('title:', this.state.title)
      console.log('date:', this.state.date)
      console.log('icon:', this.state.noLine)
      */
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className={this.state.noLine ? 'separator noline' : 'separator'} />
        {this.state.date !== null && (
          <div className='ui horizontal label'>{this.state.date}</div>
        )}
        <h4>
          {this.state.title !== null ? this.state.title : 'title not set'}
        </h4>
      </div>
    )
  }
}
